import { useEffect } from "react"
import { apiCaller } from "../../../services/apiCaller"
import { API } from "../../../services/services"
import { handleHasXTokenParamOrSendXToken, responseValidator } from "../../helpers"
import { useAppDispatch, useAppSelector } from "../../../redux/hooks"
import { setBookamrks, setBookmarkId, setVideoSettings } from "../../../redux/slices/userSlice"
import { conditions } from "../../conditions/conditions"
import { ConditionName } from "../../../interfaces/enums"
import { IBookmark } from "../../../interfaces/interfaces"
import { shallowEqual } from 'react-redux'
import { handleApplyContinuousPlayback } from "ui/src/playerComponents/continuousPlayback/continuousePlayback"

const useVideoSettings = () => {
    const dispatch = useAppDispatch();
    const { params, isFetchDetails } = useAppSelector(({ videoData: { params, isFetchDetails } }) => ({ params, isFetchDetails }), shallowEqual);
    const { isLogin } = useAppSelector(({ user: { isLogin } }) => ({ isLogin }), shallowEqual);

    useEffect(() => {
        if(conditions(ConditionName.getVideoMetaData)) {
            (async () => {
                const { data, status } = await apiCaller({ url: API().user.getVideoMetaData, headers: handleHasXTokenParamOrSendXToken() });
                if (responseValidator(status)) dispatch(setVideoSettings({ is_like: data.is_like, time: data.time }));
                else handleApplyContinuousPlayback();

                const { data:bookamrkData, status: bookmarkStatus } = await apiCaller({ url: API().user.bookmarks, headers: handleHasXTokenParamOrSendXToken() });
                if (responseValidator(bookmarkStatus) && bookamrkData.length) {
                    dispatch(setBookamrks(bookamrkData));
                    bookamrkData.find((item:IBookmark) => {
                        const queryParams = new URL(item.object_link).searchParams;
                        if (queryParams.get("type") === params.type && queryParams.get("id") === params.id) dispatch(setBookmarkId(item.id));
                    })
                }
                
            })()
        } else handleApplyContinuousPlayback();
    }, [isLogin, isFetchDetails])
}

export default useVideoSettings;